import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import fetchJybes from './fetch-jybes'
import fetchConsiders from './fetch-considers'
import fetchIgnores from './fetch-ignores'
import authStore from '@/store/auth/auth-store';

export default async function fetchReactions(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    fetchJybes(context, statement)
    if (authStore.isAuthenticated) {
        fetchConsiders(context, statement)
        fetchIgnores(context, statement)
    }
    return
}
